import React from 'react';
import type { Card, VersusTeam } from '../game/types';
import { renderCardSVG } from '../assets/svgData';

interface CardTileProps {
  card: Card | null;
  index: number;
  isSelected: boolean;
  selectedTeam?: VersusTeam | null;
  onClick: () => void;
}

export const CardTile: React.FC<CardTileProps> = ({ card, index, isSelected, selectedTeam, onClick }) => {
  const isEven = index % 2 === 0;
  const teamClass = isSelected && selectedTeam ? `selected-${selectedTeam}` : '';
  const tileClass = `card-tile ${isEven ? 'tile-even' : 'tile-odd'} ${isSelected ? 'selected' : ''} ${teamClass}`.trim();

  if (!card) {
    return <div className={tileClass} data-index={index} />;
  }

  return (
    <div
      className={tileClass}
      data-index={index}
      data-card-id={card.id}
      onClick={onClick}
      dangerouslySetInnerHTML={{ __html: renderCardSVG(card) }}
    />
  );
};

